import {
  getIsPreviewHostname,
  LOCALHOST_PREVIEW_HOSTNAME,
} from '@savgroup-front-common/configuration/preview/previewBackend';
import {
  APP_ENVS,
  currentAppEnvironment,
} from '@savgroup-front-common/constants/shared/envs';

import { getIsCypressRunning } from '../../helpers/getIsCypressRunning';

import { getIsPreviewBarHidden } from './PreviewBar.helpers';

const LOCALHOST_HOSTNAME = 'localhost';

const getShouldMountPreviewBar = (): boolean =>
  currentAppEnvironment === APP_ENVS.DEV &&
  (window.location.hostname === LOCALHOST_HOSTNAME ||
    getIsPreviewHostname(window.location.hostname)) &&
  !window.location.hostname.endsWith(LOCALHOST_PREVIEW_HOSTNAME) &&
  !getIsCypressRunning() &&
  !getIsPreviewBarHidden();

export async function mountPreviewBar(): Promise<void> {
  if (!getShouldMountPreviewBar()) {
    return;
  }

  const { renderPreviewBar } = await import('./renderPreviewBar');

  renderPreviewBar();
}
